import { createIdentifierStruct } from "@/modules/api/utils/jsonApiStructs";

import { sessionResourceType } from "./sessionResourceConsts";

export const sessionIdentifierStruct = createIdentifierStruct(
  sessionResourceType
);
